/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var spine_options_pb = require('../../../../spine/options_pb.js');
var spine_core_command_pb = require('../../../../spine/core/command_pb.js');
var spine_core_event_pb = require('../../../../spine/core/event_pb.js');
var spine_system_server_command_lifecycle_pb = require('../../../../spine/system/server/command_lifecycle_pb.js');
goog.exportSymbol('proto.spine.system.server.AssignTargetToCommand', null, global);
goog.exportSymbol('proto.spine.system.server.ScheduleCommand', null, global);

/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.spine.system.server.ScheduleCommand = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.spine.system.server.ScheduleCommand, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.spine.system.server.ScheduleCommand.displayName = 'proto.spine.system.server.ScheduleCommand';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.spine.system.server.ScheduleCommand.prototype.toObject = function(opt_includeInstance) {
  return proto.spine.system.server.ScheduleCommand.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.spine.system.server.ScheduleCommand} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.spine.system.server.ScheduleCommand.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: (f = msg.getId()) && spine_core_command_pb.CommandId.toObject(includeInstance, f),
    schedule: (f = msg.getSchedule()) && spine_core_command_pb.CommandContext.Schedule.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.spine.system.server.ScheduleCommand}
 */
proto.spine.system.server.ScheduleCommand.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.spine.system.server.ScheduleCommand;
  return proto.spine.system.server.ScheduleCommand.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.spine.system.server.ScheduleCommand} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.spine.system.server.ScheduleCommand}
 */
proto.spine.system.server.ScheduleCommand.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new spine_core_command_pb.CommandId;
      reader.readMessage(value,spine_core_command_pb.CommandId.deserializeBinaryFromReader);
      msg.setId(value);
      break;
    case 2:
      var value = new spine_core_command_pb.CommandContext.Schedule;
      reader.readMessage(value,spine_core_command_pb.CommandContext.Schedule.deserializeBinaryFromReader);
      msg.setSchedule(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.spine.system.server.ScheduleCommand.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.spine.system.server.ScheduleCommand.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.spine.system.server.ScheduleCommand} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.spine.system.server.ScheduleCommand.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      spine_core_command_pb.CommandId.serializeBinaryToWriter
    );
  }
  f = message.getSchedule();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      spine_core_command_pb.CommandContext.Schedule.serializeBinaryToWriter
    );
  }
};


/**
 * optional spine.core.CommandId id = 1;
 * @return {?proto.spine.core.CommandId}
 */
proto.spine.system.server.ScheduleCommand.prototype.getId = function() {
  return /** @type{?proto.spine.core.CommandId} */ (
    jspb.Message.getWrapperField(this, spine_core_command_pb.CommandId, 1));
};


/** @param {?proto.spine.core.CommandId|undefined} value */
proto.spine.system.server.ScheduleCommand.prototype.setId = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


proto.spine.system.server.ScheduleCommand.prototype.clearId = function() {
  this.setId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.spine.system.server.ScheduleCommand.prototype.hasId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional spine.core.CommandContext.Schedule schedule = 2;
 * @return {?proto.spine.core.CommandContext.Schedule}
 */
proto.spine.system.server.ScheduleCommand.prototype.getSchedule = function() {
  return /** @type{?proto.spine.core.CommandContext.Schedule} */ (
    jspb.Message.getWrapperField(this, spine_core_command_pb.CommandContext.Schedule, 2));
};


/** @param {?proto.spine.core.CommandContext.Schedule|undefined} value */
proto.spine.system.server.ScheduleCommand.prototype.setSchedule = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


proto.spine.system.server.ScheduleCommand.prototype.clearSchedule = function() {
  this.setSchedule(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.spine.system.server.ScheduleCommand.prototype.hasSchedule = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.spine.system.server.AssignTargetToCommand = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.spine.system.server.AssignTargetToCommand, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.spine.system.server.AssignTargetToCommand.displayName = 'proto.spine.system.server.AssignTargetToCommand';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.spine.system.server.AssignTargetToCommand.prototype.toObject = function(opt_includeInstance) {
  return proto.spine.system.server.AssignTargetToCommand.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.spine.system.server.AssignTargetToCommand} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.spine.system.server.AssignTargetToCommand.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: (f = msg.getId()) && spine_core_command_pb.CommandId.toObject(includeInstance, f),
    target: (f = msg.getTarget()) && spine_system_server_command_lifecycle_pb.CommandTarget.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.spine.system.server.AssignTargetToCommand}
 */
proto.spine.system.server.AssignTargetToCommand.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.spine.system.server.AssignTargetToCommand;
  return proto.spine.system.server.AssignTargetToCommand.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.spine.system.server.AssignTargetToCommand} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.spine.system.server.AssignTargetToCommand}
 */
proto.spine.system.server.AssignTargetToCommand.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new spine_core_command_pb.CommandId;
      reader.readMessage(value,spine_core_command_pb.CommandId.deserializeBinaryFromReader);
      msg.setId(value);
      break;
    case 2:
      var value = new spine_system_server_command_lifecycle_pb.CommandTarget;
      reader.readMessage(value,spine_system_server_command_lifecycle_pb.CommandTarget.deserializeBinaryFromReader);
      msg.setTarget(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.spine.system.server.AssignTargetToCommand.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.spine.system.server.AssignTargetToCommand.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.spine.system.server.AssignTargetToCommand} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.spine.system.server.AssignTargetToCommand.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      spine_core_command_pb.CommandId.serializeBinaryToWriter
    );
  }
  f = message.getTarget();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      spine_system_server_command_lifecycle_pb.CommandTarget.serializeBinaryToWriter
    );
  }
};


/**
 * optional spine.core.CommandId id = 1;
 * @return {?proto.spine.core.CommandId}
 */
proto.spine.system.server.AssignTargetToCommand.prototype.getId = function() {
  return /** @type{?proto.spine.core.CommandId} */ (
    jspb.Message.getWrapperField(this, spine_core_command_pb.CommandId, 1));
};


/** @param {?proto.spine.core.CommandId|undefined} value */
proto.spine.system.server.AssignTargetToCommand.prototype.setId = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


proto.spine.system.server.AssignTargetToCommand.prototype.clearId = function() {
  this.setId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.spine.system.server.AssignTargetToCommand.prototype.hasId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional CommandTarget target = 2;
 * @return {?proto.spine.system.server.CommandTarget}
 */
proto.spine.system.server.AssignTargetToCommand.prototype.getTarget = function() {
  return /** @type{?proto.spine.system.server.CommandTarget} */ (
    jspb.Message.getWrapperField(this, spine_system_server_command_lifecycle_pb.CommandTarget, 2));
};


/** @param {?proto.spine.system.server.CommandTarget|undefined} value */
proto.spine.system.server.AssignTargetToCommand.prototype.setTarget = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


proto.spine.system.server.AssignTargetToCommand.prototype.clearTarget = function() {
  this.setTarget(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.spine.system.server.AssignTargetToCommand.prototype.hasTarget = function() {
  return jspb.Message.getField(this, 2) != null;
};


goog.object.extend(exports, proto.spine.system.server);

// The code for parsing the Protobuf messages of this file from the JSON data.

let known_type_parsers = require('../../../../known_type_parsers.js');

proto.spine.system.server.ScheduleCommand.fromJson = function(json) {
  let jsObject = JSON.parse(json);
  return proto.spine.system.server.ScheduleCommand.fromObject(jsObject);
};

proto.spine.system.server.ScheduleCommand.fromObject = function(obj) {
  if (obj === null) {
    return null;
  }
  
  let msg = new proto.spine.system.server.ScheduleCommand();
  
  if (obj.id !== undefined) {
    if (obj.id === null) {
      msg.setId(null);
    } else {
      let value = proto.spine.core.CommandId.fromObject(obj.id);
      msg.setId(value);
    }
  }
  
  if (obj.schedule !== undefined) {
    if (obj.schedule === null) {
      msg.setSchedule(null);
    } else {
      let value = proto.spine.core.CommandContext.Schedule.fromObject(obj.schedule);
      msg.setSchedule(value);
    }
  }
  return msg;
};

proto.spine.system.server.AssignTargetToCommand.fromJson = function(json) {
  let jsObject = JSON.parse(json);
  return proto.spine.system.server.AssignTargetToCommand.fromObject(jsObject);
};

proto.spine.system.server.AssignTargetToCommand.fromObject = function(obj) {
  if (obj === null) {
    return null;
  }
  
  let msg = new proto.spine.system.server.AssignTargetToCommand();
  
  if (obj.id !== undefined) {
    if (obj.id === null) {
      msg.setId(null);
    } else {
      let value = proto.spine.core.CommandId.fromObject(obj.id);
      msg.setId(value);
    }
  }
  
  if (obj.target !== undefined) {
    if (obj.target === null) {
      msg.setTarget(null);
    } else {
      let value = proto.spine.system.server.CommandTarget.fromObject(obj.target);
      msg.setTarget(value);
    }
  }
  return msg;
};
